module.exports = __webpack_public_path__ + "img/screen-top.79a164d8.png";